const metypeConfig = {
  en: {
    metypeEnabled: true,
    metypeHost: "https://www.metype.com",
    metypeAccountId: "2",
    primaryColor: "#000",
    secondaryColor: "#f2f2f2",
    className: "story-comments-widget",
    publisher: "National Herald"
  },
  hi: {
    metypeEnabled: true,
    metypeHost: "https://www.metype.com",
    metypeAccountId: "51",
    primaryColor: "#000",
    secondaryColor: "#f2f2f2",
    className: "story-comments-widget",
    publisher: "Navjivan"
  },
  ur: {
    metypeEnabled: true,
    metypeHost: "https://www.metype.com",
    metypeAccountId: "52",
    primaryColor: "#000",
    secondaryColor: "#f2f2f2",
    className: "story-comments-widget",
    publisher: "Qaumi Awaz"
  }
};

module.exports = metypeConfig;
